import { useLocalStorage } from 'app/hooks/useLocalStorage';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'urql';
import { PlaceHolder } from '../../ui-components/PlaceHolder/PlaceHolder';
import ContentList from '../../ui-components/ContentList/ContentList';
import QUERY from './Favorites.graphql';
// import env from 'app/env';
import {
    StyledPlaceHolderContainer,
    StyledPlaceHolderHeaderWrapper,
    StyledPlaceHolderHeader,
} from './ContinueWatchingList.styles';
import { trackCustomEvent } from 'app/utils/statistics/clientStatistics';
import { trackFavorite } from 'app/utils/statistics/customEvents';

const FavoritesPlaceholder = () => (
    <StyledPlaceHolderContainer>
        <StyledPlaceHolderHeaderWrapper>
            <StyledPlaceHolderHeader>Min lista</StyledPlaceHolderHeader>
        </StyledPlaceHolderHeaderWrapper>
        <PlaceHolder nrOfItems={4} />
    </StyledPlaceHolderContainer>
);

let isMounted = false;

const FavoritesList = ({ onItemClick }) => {
    const [favorites, setFavorites] = useLocalStorage('favorites', []);

    const [result] = useQuery({
        query: QUERY,
        variables: {
            titleIds: favorites,
        },
        context: React.useMemo(
            () => ({
                preferGetMethod: false,
            }),
            []
        ),
    });

    const { data, fetching, error } = result;

    if (favorites.length === 0) {
        return null;
    }

    if (fetching) {
        return <FavoritesPlaceholder key={'placeholder'} />;
    }

    if (!data || error) {
        return null;
    }

    const handleOnDelete = (itemsToDelete) => {
        const ids = itemsToDelete.map((item) => item.svtId);

        const filteredFavorites = favorites.filter((favorite) => !ids.includes(favorite));

        ids.forEach((id) => {
            trackCustomEvent(trackFavorite(id, false));
        });

        setFavorites(filteredFavorites);
    };

    return (
        <ContentList
            id="favorites"
            key="favorites-list"
            url="/min-lista"
            items={data.favorites.items}
            headerText={data.favorites.name}
            expandable={false}
            onDeleteItems={handleOnDelete}
            regTestSpec="favorites-list"
            deletableItems
            onItemClick={onItemClick}
        />
    );
};

const FavouritesListContainer = ({ onItemClick }) => {
    // Favorites can't render on server
    const [mounted, setMounted] = useState(isMounted);

    useEffect(() => {
        setMounted(true);
        // Favorites should always render on client, otherwise page scroll position will "shift" when user
        // hits back in client
        isMounted = true;
    }, []);

    if (mounted) {
        return <FavoritesList onItemClick={onItemClick} />;
    }

    return null;
};

export default FavouritesListContainer;
